import { camp67AndKumbhPage } from '../pages/page-the-camp.camp67-and-kumbh';
import { ContentPage } from '../page-factory/content-page';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(camp67AndKumbhPage);

export default function Camp67AndKumbhPage() {
  return <ContentPage {...camp67AndKumbhPage} />;
}
